import { z } from 'zod'

export const listResponseSchema = <
  T extends z.ZodTypeAny,
  K extends z.ZodTypeAny
>(
  resultSchema: T,
  totalSchema?: K
) =>
  z.object({
    pagination: z.object({
      count: z.number(), // number of rows in the current pagination
      start: z.number(), // offset: where current pagination starts in the total rows
      limit: z.number(), // limit: number of rows provided every time
      end: z.number(), // where current pagination ends in the total rows
      next: z.boolean(), // if there is a next page
      prev: z.boolean(), // if there is a previous page
      pages: z.number(), // total number of pages (must coincide with last in field range)
      range: z.array(z.number()), // all possible pages according to Math.round(total/limit)  ie. [1,2,3]
      total: z.number() // total rows in DB
    }),
    results: z.array(resultSchema),
    status: z.boolean(),
    total: totalSchema ? totalSchema.optional() : z.undefined()
  })

export type ListResponse<T, K = any> = {
  pagination: {
    count: number
    start: number
    limit: number
    end: number
    next: boolean
    prev: boolean
    pages: number
    range: number[]
    total: number
  }
  results: T[]
  status: boolean
  total?: K
}
